"use client";
import Button from "@/components/UI/Button/Button";
import { useCartContext } from "@/providers/CartContextProvider";
import { Form } from "@radix-ui/react-form";
import { useRouter } from "next/navigation";
import { FormProvider, useForm } from "react-hook-form";
import { handleGoToCheckout } from "./_actions/checkoutRedirect";

import styles from "./CheckoutButton.module.scss";

interface Props {
	className?: string;
	children?: React.ReactNode;
}

export const CheckoutButton = ({ className, children }: Props) => {
	const { cart, setIsModifyingCart } = useCartContext();

	const router = useRouter();

	const { handleSubmit, register, ...methods } = useForm();

	if (!cart) {
		return null;
	}

	const formSubmit = async () => {
		setIsModifyingCart(true);
		const result = await handleGoToCheckout(cart?.id);

		if (result.status === "success") {
			if (result.data) {
				router.push(result.data.sso);
			}
		}

		setIsModifyingCart(false);
	};

	return (
		<FormProvider handleSubmit={handleSubmit} register={register} {...methods}>
			<Form onSubmit={handleSubmit(formSubmit)} className={styles.form}>
				<Button className={className} as='button' type='submit'>
					{children}
				</Button>
			</Form>
		</FormProvider>
	);
};
